import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import Footer from "../ones/Footer";
import ProjectsBanner from "../ones/ProjectsBanner";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    // run initializations here
    setReady(false);
    // ..
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <ProjectsBanner />
        { appContext.navItem === "projects" ? <Footer /> : null }
      </>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
